import { useContext } from "react";

import { SxProps } from "@mui/material";
import { FormType, formatDateTimeToLocaleString, PaymentMethod } from "@simplyk/common";

import { FrontendFormContext } from "../../../../../../common/contexts/FrontendFormContext";
import { useLocaleContext } from "../../../../../../common/contexts/LocaleContext";

import { useFormV2Context } from "@/canvas/features/FormV2/contexts/FormV2Context";
import { shouldDisplayAuctionRateTaxMention } from "@/common/helpers/rates";
import { useTranslate } from "@/common/hooks/useTranslate";
import { FormInfobox } from "@/forms-design-system/FormInfobox";
import { Info } from "@/icons/outlined";

export const AuctionPaymentInfoBox = ({ sx }: { sx?: SxProps }) => {
  const { t } = useTranslate();
  const { locale } = useLocaleContext();
  const { selectedOccurrenceWithRates, formObject } = useFormV2Context(FormType.Ticketing);
  const { selectedPaymentMethod } = useContext(FrontendFormContext);

  const selectedOccurrence = selectedOccurrenceWithRates?.occurrence;
  const hasTaxedItems = (formObject?.rates ?? []).some(shouldDisplayAuctionRateTaxMention);

  if (selectedPaymentMethod === PaymentMethod.Cash || !selectedOccurrence?.endUtc) {
    return null;
  }

  return (
    <FormInfobox
      variant="emphasis"
      icon={<Info />}
      title={t("ticketing", "auction.summary.chargeInfo.title")}
      description={[
        t("ticketing", "auction.summary.chargeInfo.body", {
          date: formatDateTimeToLocaleString(selectedOccurrence?.endUtc, locale, {
            month: "long",
            day: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          }),
        }),
        hasTaxedItems ? t("ticketing", "auctionV2.taxNotice") : null,
      ]
        .filter(Boolean)
        .join(" ")}
      sx={sx}
    />
  );
};
